import React from 'react';

import Map from '@rover/icons/svg/map.svg';
import { Flex, Heading, Text } from '@rover/kibble/core';
import useDeviceContext from '@rover/react-lib/src/context/useDeviceContext';

const ICON_SIZE = 16;

interface GroomingInfoColumnProps {
  resultNumber: number;
  shortName: string;
  distanceDisplay: string;
}

function GroomingInfoColumn({
  resultNumber,
  shortName,
  distanceDisplay,
}: GroomingInfoColumnProps): JSX.Element {
  const { isDesktop } = useDeviceContext();

  return (
    <Flex flex="1 1 0" flexDirection="column" px="4x" gap="1x">
      <Heading size={isDesktop ? '300' : '200'} mb="0x">
        {`${resultNumber}. ${shortName}`}
      </Heading>
      {distanceDisplay && (
        <Flex gap="1x" alignItems="flex-start">
          <Map width={ICON_SIZE} height={ICON_SIZE} />
          <Text size="100">{distanceDisplay}</Text>
        </Flex>
      )}
    </Flex>
  );
}

export default GroomingInfoColumn;
